<template>
    <TreeTable :value="nodes"  :expandedKeys="expandedKeys" >
        <Column field="label" :header="title" :expander="true" bodyClass="col-10"></Column>
        <Column header="pilih" headerClass="col-2" bodyClass="col-1">
            <template #body="slotProps" >
                <Checkbox   
                    v-if="!slotProps.node.children || slotProps.node.children.length == 0"
                    :value="slotProps.node.data.label" 
                    v-model="model"/>

            </template>
        </Column>
    </TreeTable>
</template>

<script>
import TreeTable from 'primevue/treetable';
import TreeSelect from 'primevue/treeselect';
import Column from 'primevue/column';
import Checkbox from 'primevue/checkbox';
import MenuService from '../Services/MenuService';


export default {
    components: {
        TreeSelect,
        TreeTable,
        Column,
        Checkbox
    },
    props: {
        title : {
            type : String,
            default : 'Menu'
        },
        modelValue : {
            type : Array,
            default : () => []
        },
    },
    computed : {
        model : {
            get() {
                return this.modelValue;
            },
            set(value) {
                this.$emit('update:modelValue', value);
            }
        }
    },
    menuService : null,
    data() {
        return { 
            nodes : [],
            expandedKeys : {},
            selected_menu : [],
        }
    },
    created () {
        this.menuService = new MenuService();
    },
    mounted () {
        this.menuService.getData().then(response => {
            var temp = response.data;
            // recursively change data element to label elemen
            // temp.forEach(function(element) {
            //     element.label = element.data.label;
            //     element.data = element.data.label;
            //     if(element.children) {
            //         element.children.forEach(function(child) {
            //             child.label = child.data.label;
            //             child.data = child.data.label;
            //         });
            //     }
            // });
            // console.log(temp);
            this.nodes = temp;
            this.expandAll();
        });
        
    },
    methods : {
        console_log(param){
            console.log(param);
            console.log('halo');
            return param;
        },
        expandAll() {
            for (let node of this.nodes) {
                this.expandNode(node);
            }

            this.expandedKeys = {...this.expandedKeys};
        },
        expandNode(node) {
            if (node.children && node.children.length) {
                this.expandedKeys[node.key] = true;

                for (let child of node.children) {
                    this.expandNode(child);
                }
            }
        }
    }
}
</script>

<style>

</style>